import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';

/**
 * ActionIconButton - A unified component for table action buttons
 *
 * @param {string} title - Tooltip text
 * @param {React.ComponentType} icon - Icon component from src/icons
 * @param {string} [to] - Navigation path (uses Link)
 * @param {function} [onClick] - Click handler
 * @param {boolean} [disabled] - Disabled state
 * @param {string} [color] - Icon color (can use ICON_STATES or any color)
 * @param {object} [iconProps] - Additional props for the icon
 * @param {object} [buttonProps] - Additional props for the IconButton
 * @param {React.ReactNode} [children] - Optional content to render alongside the icon
 */
const ActionIconButton = ({
    title,
    icon: Icon,
    to,
    onClick,
    disabled = false,
    color,
    iconProps = {},
    buttonProps = {},
    children,
    ...rest
}) => {
    const iconElement = (
        <>
            <Icon color={color} {...iconProps} />
            {children}
        </>
    );

    const buttonElement = to ? (
        <IconButton component={Link} to={to} disabled={disabled} {...buttonProps} {...rest}>
            {iconElement}
        </IconButton>
    ) : (
        <IconButton onClick={onClick} disabled={disabled} {...buttonProps} {...rest}>
            {iconElement}
        </IconButton>
    );

    // When disabled, wrap in span so Tooltip still works
    const wrappedButton = disabled ? <span>{buttonElement}</span> : buttonElement;

    return <Tooltip title={title}>{wrappedButton}</Tooltip>;
};

export default ActionIconButton;
